import styles from "@/styles/components/Stepper.module.css"

/*
 * A labelled −/value/+ row.
 *
 * Extracted from the lobby's session rules when the in-session settings dialog
 * needed the same control: both write the same config keys, and a room that saw
 * two different steppers for `handCap` would reasonably assume they were two
 * different limits.
 *
 * `format` exists because not every value reads as its number — `handCap` of 0
 * means no limit, and prints as ∞.
 */

interface StepperProps {
  label: string
  hint?: string
  value: number
  min: number
  max: number
  format?: (value: number) => string
  onChange: (value: number) => void
}

export default function Stepper({ label, hint, value, min, max, format, onChange }: StepperProps) {
  return (
    <div className={styles.row}>
      <span className={styles.rowText}>
        <span className={styles.rowLabel}>{label}</span>
        {hint ? <span className={styles.hint}>{hint}</span> : null}
      </span>
      <span className={styles.stepper}>
        <button
          type="button"
          className={styles.step}
          data-stepper=""
          aria-label={`Fewer — ${label}`}
          disabled={value <= min}
          onClick={() => onChange(Math.max(min, value - 1))}
        >
          −
        </button>
        <span className={styles.stepValue}>{format ? format(value) : value}</span>
        <button
          type="button"
          className={styles.step}
          aria-label={`More — ${label}`}
          disabled={value >= max}
          onClick={() => onChange(Math.min(max, value + 1))}
        >
          +
        </button>
      </span>
    </div>
  )
}
